import React from 'react';

import { AttributionImageLoaderAndDisplay, ImagePoint} from './AttributionImageDisplay';
import { AltAttributionUtil } from './InvestigationDisplay'

import * as messages from '@radnuc/messages';
import * as d3 from 'd3';

//import * as query from './Query';
//import { uuidToString } from './UUID';

import './PrimaryDisplay.css'
//import '../system-configuration.ts'

import icon_attention_logo from './img/icon-attention.png'
import icon_industrial_logo from './img/icon-industrial.png'
import icon_medical_logo from './img/icon-medical.png'
import icon_nuclear_logo from './img/icon-nuclear.png'
import icon_norm_logo from './img/icon-norm.png'
import icon_truck_logo from './img/truck-front-icon-white.png'

type GammaCount = { time: number, sum: number, dose: number, num_det:number, livetime: number }
type NeutronCount = { time: number, count: number, num_det: number, livetime: number }
type SourceRect = { rect: messages.Contextual.ImageRect|null, color: string|null}
export type LaneNumberLabelPair = {laneNumber: number, laneLabel:String}
type Investigation = messages.Rad.Investigation | messages.Encounter.Encounter;

export type LaneDisplayInterface = {
    laneToDisplay:number|undefined,
    laneNumberAndLabel?: LaneNumberLabelPair[],
    select: (lane: number) =>void, unselect:()=>void }

export interface PrimaryDisplayProps {
    radiationData: messages.Rad.RadiationReading[] | null,
    neutronData: messages.Rad.NeutronReading[] | null,
    investigations: Investigation[],
    replayInvestigation?: Investigation,
    investigationsNotAcknowledged?: Investigation[],
    attributionSummary?: Map<String,messages.Contextual.SourceAttributionSummary>,
    liveStream: boolean,
    liveRadiationData: messages.Rad.RadiationReading[] | null,
    liveNeutronData: messages.Rad.NeutronReading[] | null,
    isCommercial?: boolean,
    laneDisplayInterface?: LaneDisplayInterface,
    lineOverlayMap?: Map<number,ImagePoint[]>,
    isDualStanchion?: boolean,
}

export interface PrimaryDisplayState {
    maxGammaPlotValue: 4000;
    maxNeutronPlotValue: 40;
}

export class PrimaryDisplay extends React.Component<PrimaryDisplayProps, PrimaryDisplayState> {
    base: HTMLDivElement | null
    updateRef: (element: HTMLDivElement) => void
    num_lanes: number = 4
    laneNumbers: number[] = []
    laneLabels: String[] = []

    constructor(props: PrimaryDisplayProps) {
        super(props)
        this.base = null

        this.resize = this.resize.bind(this);

        this.updateRef = (element: HTMLDivElement) => {
            this.base = element;
            this.render();
        };
        this.calculateNumLanesAndLabels();
    }

    componentDidMount() {
        window.addEventListener("resize", this.resize);
    }

    componentDidUpdate(prevProps:PrimaryDisplayProps){
        if(this.props.laneDisplayInterface !== prevProps.laneDisplayInterface)
            this.calculateNumLanesAndLabels();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize(){
        this.render();
    }

    calculateNumLanesAndLabels(){
        const num_lanes = this.props.laneDisplayInterface?.laneNumberAndLabel?.length || 4;
        this.laneNumbers = new Array(num_lanes);
        this.laneLabels = new Array(num_lanes);
        if(this.props.laneDisplayInterface?.laneNumberAndLabel){
            this.props.laneDisplayInterface?.laneNumberAndLabel.forEach((lane,idx)=>{
                this.laneNumbers[idx]=(lane.laneNumber);
                this.laneLabels[idx]=(lane.laneLabel);
            });
        } else {
            //LaneNumberAndLabel Undefined
            for(let i=0;i<num_lanes;i++){
                this.laneNumbers[i]=(i);
                this.laneLabels[i]=((i+1).toFixed(0));
            }
        }
    }


    render() {

        let primary_display_body;
        if(this.props.laneDisplayInterface){
            if(this.props.laneDisplayInterface.laneToDisplay === undefined){

                let lanes:JSX.Element[] = [];
                this.laneNumbers.forEach((num,idx)=>{
                    const lane =
                    <PrimaryLaneDisplay key={idx}
                            lanePosition={this.laneNumbers[idx]} lanesTotal={this.num_lanes} laneLabel={this.laneLabels[idx]}
                            radiationData={this.props.radiationData} neutronData={this.props.neutronData}
                            liveRadiationData={this.props.liveRadiationData} liveNeutronData={this.props.liveNeutronData}
                            investigations={this.props.investigations} replayInvestigation={this.props.replayInvestigation}
                            investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                            attributionSummary={this.props.attributionSummary} liveStream={this.props.liveStream} isCommercial={this.props.isCommercial}
                            lineOverlayMap={this.props.lineOverlayMap}/>
                    lanes.push(lane);
                });

                primary_display_body=
                    <div key={this.props.laneDisplayInterface.laneToDisplay} style={{ display: 'flex', flexDirection: 'row', height: '100%' }}>
                        {lanes}
                    </div>
            } else {
                primary_display_body=
                    <div key={this.props.laneDisplayInterface.laneToDisplay} style={{ display: 'flex', flexDirection: 'row', height: '100%'}}>
                        <PrimaryLaneDisplay lanePosition={this.props.laneDisplayInterface.laneToDisplay} lanesTotal={this.num_lanes} laneLabel={this.laneLabels[this.props.laneDisplayInterface.laneToDisplay]}
                                radiationData={this.props.radiationData} neutronData={this.props.neutronData}
                                liveRadiationData={this.props.liveRadiationData} liveNeutronData={this.props.liveNeutronData}
                                investigations={this.props.investigations} replayInvestigation={this.props.replayInvestigation}
                                investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                                attributionSummary={this.props.attributionSummary} liveStream={this.props.liveStream}
                                isDualStanchion={this.props.isDualStanchion}
                                isCommercial={this.props.isCommercial} singleLaneView={true} lineOverlayMap={this.props.lineOverlayMap}/>
                    </div>

            }
        }


        return (
            <>
            {primary_display_body}
            </>
        )
    }

}
export default PrimaryDisplay

//******************************************************************************

export interface PrimaryLaneDisplayProps {
    lanePosition: number,
    lanesTotal: number,
    laneLabel?: String,
    radiationData: messages.Rad.RadiationReading[] | null,
    liveRadiationData: messages.Rad.RadiationReading[] | null,
    neutronData: messages.Rad.NeutronReading[] | null,
    liveNeutronData: messages.Rad.NeutronReading[] | null,
    investigations: Investigation[],
    replayInvestigation?: Investigation,
    investigationsNotAcknowledged?:Investigation[],
    attributionSummary?: Map<String,messages.Contextual.SourceAttributionSummary>,
    liveStream: boolean,
    isCommercial?: boolean,
    singleLaneView?:boolean,
    lineOverlayMap?: Map<number,ImagePoint[]>,
    isDualStanchion?:boolean,
}

export class PrimaryLaneDisplay extends React.Component<PrimaryLaneDisplayProps> {

    gammaCounts: GammaCount[];
    neutronCounts: NeutronCount[];
    maxGammaCountAllData: number = 0;
    maxNeutronCountAllData: number = 0;

    lastTimeForceRedraw: number = 0;
    dominantIsotope: string | null = null;
    constructor(props: PrimaryLaneDisplayProps) {
        super(props)

        //this.spectra = [];
        this.gammaCounts = [];
        this.neutronCounts = [];
    }

    addVector(a: number[], b: number[] | null) {
        if (b !== null)
            return a.map((e, i) => e + b[i]);
        else
            return a;
    }


    calcGammaCount() {
        //Calculates count sum and average spectrum of all detectors
        this.gammaCounts = [];
        this.maxGammaCountAllData = 0;
        if (this.props.radiationData !== null && this.props.radiationData.length > 0) {
            this.props.radiationData.forEach((data) => {
                let this_lane_sum_spectrum = 0.0;
                let this_lane_livetime = 0.0;
                let this_lane_dose = 0.0;
                let this_lane_num_det = 0;
                let count_all_lanes:number[] = Array(this.props.lanesTotal).fill(0);
                let livetime_all_lanes:number[] = Array(this.props.lanesTotal).fill(0);
                data.detectors.forEach((det) => {
                    if(det.spectrum !== null){
                        const sum = d3.sum(det.spectrum);
                        if(det.lane_position === this.props.lanePosition){
                            this_lane_sum_spectrum += sum;
                            this_lane_dose += det.dose_rate;
                            this_lane_livetime += det.livetime;
                            this_lane_num_det++;
                        }
                        count_all_lanes[det.lane_position] += sum;   //For plot scale across all lanes
                        livetime_all_lanes[det.lane_position] += det.livetime;
                    }
                });
                for(var i=0;i<this.props.lanesTotal;i++){
                    if(livetime_all_lanes[i] > 0){
                        count_all_lanes[i] = count_all_lanes[i]/livetime_all_lanes[i];
                    } else {
                        count_all_lanes[i] = 0;
                    }
                }

                const this_maxGammaAllLanes = d3.max(count_all_lanes) || 0;
                if(this.maxGammaCountAllData < this_maxGammaAllLanes) {
                    this.maxGammaCountAllData = this_maxGammaAllLanes;
                }


                if (this_lane_livetime === 0) {
                    this_lane_livetime = 1;
                    this_lane_sum_spectrum = 0;
                }

                var result = {
                    time: data.time,
                    sum: this_lane_sum_spectrum,
                    dose: this_lane_dose,
                    livetime: this_lane_livetime,
                    num_det: this_lane_num_det,
                }
                this.gammaCounts.push(result);
            });
        }
    }

    calcNeutronCount(){
        this.neutronCounts = [];
        this.maxNeutronCountAllData = 0;
        if (this.props.neutronData !== null && this.props.neutronData.length > 0) {
            this.props.neutronData.forEach((data) => {

                let this_lane_sum_count = 0.0;
                let this_lane_livetime = 0.0;
                let this_lane_num_det = 0;
                let count_all_lanes:number[] = Array(this.props.lanesTotal).fill(0);
                let livetime_all_lanes:number[] = Array(this.props.lanesTotal).fill(0);
                if(data.detectors !== undefined){
                    data.detectors.forEach((det) => {
                        if(det.lane_position === this.props.lanePosition){
                            this_lane_sum_count += det.count;
                            this_lane_livetime += det.livetime;
                            this_lane_num_det++;
                        }
                        count_all_lanes[det.lane_position] += det.count;   //For plot scale across all lanes
                        livetime_all_lanes[det.lane_position] += det.livetime;
                    });
                    const this_maxNeutronAllLanes = d3.max(count_all_lanes) || 0;
                    if(this.maxNeutronCountAllData < this_maxNeutronAllLanes) {
                        this.maxNeutronCountAllData = this_maxNeutronAllLanes;
                    }

                    if (this_lane_livetime === 0) {
                        this_lane_livetime = 1;
                        this_lane_sum_count = 0;
                    }

                    const result = {
                        time: data.time,
                        count: this_lane_sum_count,
                        livetime: this_lane_livetime,
                        num_det: this_lane_num_det,
                    };
                    this.neutronCounts.push(result);
                }
            });
        }
    };
    render() {
        this.calcGammaCount();
        this.calcNeutronCount();
        let lane_display_body;
        if(this.props.singleLaneView){
            lane_display_body=
                <div className='Lane' style={{ display: 'flex', flex: 1, flexDirection: 'column', minWidth:'700px'}}>
                <LaneIndicatorDisplay lanePosition={this.props.lanePosition} laneLabel={"Lane "+this.props.laneLabel} investigations={this.props.investigations} liveStream={this.props.liveStream}/>
                        <div className='single-lane-view' style={{ display: 'flex', flex: 0, flexDirection: 'row'}}>
                            <div style={{ display: 'flex', width:'50%', flexDirection: 'row', flex: 1 }}>
                                <LaneCountAndDoseDisplay lanePosition={this.props.lanePosition} liveRadiationData={this.props.liveRadiationData} isCommercial={this.props.isCommercial}/>
                                <LaneNeutronCountDisplay lanePosition={this.props.lanePosition} liveNeutronData={this.props.liveNeutronData}/>
                            </div>
                            <div style={{ display: 'flex', width:'50%', flexDirection: 'column' }}>
                                <div className='single-lane-view' style={{ display: 'flex', flex: 1, flexDirection: 'column'}}>
                                    <PrimaryCountHistoryPlot gammaCounts={this.gammaCounts} maxGamma={this.maxGammaCountAllData}
                                                             neutronCounts={this.neutronCounts} maxNeutron={this.maxNeutronCountAllData}
                                                             replayTime={undefined} liveStream={this.props.liveStream}/>
                                </div>
                            </div>
                        </div>
                        <div className='single-lane-view-context' style={{ display: 'flex', flex: 1, flexDirection: 'column'}}>

                            <LaneHealthAndContextDisplay lanePosition={this.props.lanePosition} gammaCounts={this.gammaCounts} neutronCounts={this.neutronCounts}
                                                    investigations={this.props.investigations} replayInvestigation={this.props.replayInvestigation}
                                                    investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                                                    attributionSummary={this.props.attributionSummary}
                                                    liveStream={this.props.liveStream} isCommercial={this.props.isCommercial} showAttrImage={true}
                                                    isDualStanchion={this.props.isDualStanchion}
                                                    lineOverlayMap={this.props.lineOverlayMap} singleLaneView={this.props.singleLaneView}/>
                        </div>
                </div>
        } else {
            lane_display_body=
                <div className='Lane' style={{ display: 'flex', flex: 1, flexDirection: 'column', height: '100%' }}>
                    <LaneIndicatorDisplay lanePosition={this.props.lanePosition} laneLabel={this.props.laneLabel} investigations={this.props.investigations} liveStream={this.props.liveStream}/>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline'}}>
                        <LaneCountAndDoseDisplay lanePosition={this.props.lanePosition} liveRadiationData={this.props.liveRadiationData} isCommercial={this.props.isCommercial}/>
                        <LaneNeutronCountDisplay lanePosition={this.props.lanePosition} liveNeutronData={this.props.liveNeutronData}/>
                    </div>
                    <PrimaryCountHistoryPlot gammaCounts={this.gammaCounts} maxGamma={this.maxGammaCountAllData}
                                             neutronCounts={this.neutronCounts} maxNeutron={this.maxNeutronCountAllData}
                                             replayTime={undefined} liveStream={this.props.liveStream}/>

                    <LaneHealthAndContextDisplay lanePosition={this.props.lanePosition} gammaCounts={this.gammaCounts} neutronCounts={this.neutronCounts}
                                            investigations={this.props.investigations} replayInvestigation={this.props.replayInvestigation}
                                            investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                                            attributionSummary={this.props.attributionSummary}
                                            liveStream={this.props.liveStream} isCommercial={this.props.isCommercial} showAttrImage={true}
                                            isDualStanchion={this.props.isDualStanchion}
                                            lineOverlayMap={this.props.lineOverlayMap}/>
                </div>
        }
        return (
            <>
            {lane_display_body}
            </>
        );
    }
}

//******************************************************************************

export interface LaneIndicatiorDisplayProps {
    lanePosition: number,
    laneLabel?: String,
    investigations: Investigation[],
    liveStream: boolean,
}

export class LaneIndicatorDisplay extends React.Component<LaneIndicatiorDisplayProps> {

    isAltAttrInThisLane(inv:Investigation) {
        let result = false;
        if(!('type' in inv)){
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null){
                inv.alternative_attributions.forEach((attr=>{
                    if(attr.source_lane !== undefined && attr.source_lane !== null){
                        if(attr.source_lane === this.props.lanePosition){
                            if(attr.isotopes.length > 0)
                                result = true;
                        }
                    }
                }));
            }
        }
        return result;
    }

    getDoseAlarmClass(){
        let statusClass = '';
        if(this.props.investigations.length > 0){
            let inv = this.props.investigations[this.props.investigations.length-1]
            if(!inv.finalized && inv.isotopes.length > 0 && inv.source_lane === this.props.lanePosition){
                statusClass = 'alarm';
            }
            //Also alarm if alternate attribution is present
            if(!inv.finalized && this.isAltAttrInThisLane(inv)){
                statusClass = 'alarm';
            }
        }
        return(statusClass)
    }

    render() {
        let laneStatusClass = this.getDoseAlarmClass();
        let laneLabel = this.props.laneLabel || (this.props.lanePosition+1).toFixed(0)
        return (
            <div className="primary-lane-indicator-wrap">
                <div className={"primary-lane-indicator-container "+laneStatusClass}>{laneLabel}</div>
            </div>
        );
    }
}

//******************************************************************************

interface LaneCountAndDoseDisplayProps { lanePosition: number, liveRadiationData: messages.Rad.RadiationReading[] | null, doseAlarmThresh?: number | null, isCommercial?: boolean} //, healthData: HealthData }
interface LaneCountAndDoseDisplayState { time: Date }
export class LaneCountAndDoseDisplay extends React.Component<LaneCountAndDoseDisplayProps, LaneCountAndDoseDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    numDetectorsInLane: number = 0;
    avgDoseRate: number = 0;
    constructor(props: LaneCountAndDoseDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount() {
        if (this.heartbeatTimer !== null) {
            clearTimeout(this.heartbeatTimer);
        }
    }

    calculateCountAndDose(rebinned_spectrum: messages.Rad.RadiationReading){
        var avg_dose = 0;
        var avg_count = 0;
        var num_det_dose = 0;
        var num_det_count = 0;
        var dose_rate_string = 'N/A';
        var count_rate_string = 'N/A';

        if(rebinned_spectrum !== undefined){

            rebinned_spectrum.detectors.forEach((det)=> {
                if (det.spectrum != null) {
                    if(det.lane_position === this.props.lanePosition){
                        avg_count = avg_count + (det.spectrum.reduce(function(a, b) {
                            return a + b;
                        }, 0))/det.livetime; //to convert to cps
                        num_det_count++;
                    }
                }
                if (det.dose_rate != null) {
                    if(det.lane_position === this.props.lanePosition){
                        avg_dose = avg_dose + det.dose_rate;
                        num_det_dose++;
                    }
                }
            });

            if (num_det_dose > 0) {
                avg_dose = avg_dose / num_det_dose;
                //Dose rate string
                if(avg_dose >= 100){
                    dose_rate_string = avg_dose.toFixed(0);
                } else if(avg_dose >= 10){
                    dose_rate_string = avg_dose.toFixed(1);
                } else {
                    dose_rate_string = avg_dose.toFixed(2);
                }
            } else {
                dose_rate_string = 'N/A';
            }
            if (num_det_count > 0) {
                avg_count = avg_count / num_det_count;
                count_rate_string = avg_count.toFixed(0);
            } else {
                count_rate_string = 'N/A';
            }
        }
        this.numDetectorsInLane = num_det_count;
        this.avgDoseRate = avg_dose;
        /*
        if(this.props.healthData.state === messages.Rad.HealthState.BAD){
            dose_rate_string = 'N/A';
            count_rate_string = 'N/A';
        }
        */

        return({dose_rate_string, count_rate_string});
    }

    getStatusClass(){
        let statusClass = 'good';
        if(this.props.isCommercial){
            if(this.numDetectorsInLane===1){
                statusClass = 'degraded';
            } else if(this.numDetectorsInLane <= 0 ){
                statusClass = 'bad';
            }
        } else {
            if(this.numDetectorsInLane <= 0 ){
                statusClass = 'bad';
            }
        }
        return(statusClass)
    }

    getDoseAlarmClass(){
        let statusClass = '';
        //const avg_dose = gammaData.dose / gammaData.num_det;
        if(this.props.doseAlarmThresh){
            if(this.props.doseAlarmThresh !== null){
                if(this.avgDoseRate >= this.props.doseAlarmThresh ){
                    statusClass = 'alarm';
                }
            }
        }
        return(statusClass)
    }
    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    render() {

        this.startTimer();
        //const thisHealthData = this.props.healthData;
        var healthStatusClass = "";
        var doseAlarmStatusClass = "";
        var dose_display_string = 'N/A';
        var count_display_string = 'N/A';
        //if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
        if(this.props.liveRadiationData !== null){
            if(this.props.liveRadiationData.length > 0){
                if(this.props.liveRadiationData[this.props.liveRadiationData.length-1].time+this.heartbeatInterval >= new Date().getTime()){
                    const result = this.calculateCountAndDose(this.props.liveRadiationData[this.props.liveRadiationData.length-1]);
                    healthStatusClass = this.getStatusClass();
                    doseAlarmStatusClass =this.getDoseAlarmClass();
                    dose_display_string = result.dose_rate_string;
                    count_display_string = result.count_rate_string;
                } else {
                    healthStatusClass =  "offline";
                }
            } else {
                //No DATA
                healthStatusClass =  "offline";
            }
        }

        const count_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{count_display_string}</label>
                <label className="units">cps</label>
            </div>
        const dose_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"dose metric "+healthStatusClass+" "+doseAlarmStatusClass}>{dose_display_string}</label>
                <label className={"units dose "+doseAlarmStatusClass}>&micro;R/hr</label>
            </div>
        return (
            <>
                    <div className="primary-metric-container small" style={{marginTop:'2px', marginBottom:'2px', padding: '2px'}}>
                        <label className="metric-title">Count Rate</label>
                        {count_body}
                    </div>
                    <div className={"primary-metric-container small dose "+doseAlarmStatusClass} style={{marginTop:'2px', marginBottom:'2px', padding: '2px'}}>
                        <label className={"metric-title dose "+doseAlarmStatusClass}>Dose Rate</label>
                        {dose_body}
                    </div>
            </>
        )
    }
}

//******************************************************************************

interface LaneNeutronCountDisplayProps { lanePosition: number, liveNeutronData: messages.Rad.NeutronReading[] | null }
interface LaneNeutronCountDisplayState { time: Date }
export class LaneNeutronCountDisplay extends React.Component<LaneNeutronCountDisplayProps, LaneNeutronCountDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    numDetectorsInLane: number = 0;

    constructor(props: LaneNeutronCountDisplayProps) {
        super(props)
        this.state = {
            time: new Date()
        }
    }

    componentWillUnmount() {
        if (this.heartbeatTimer !== null) {
            clearTimeout(this.heartbeatTimer);
        }
    }

    calculateNeutronCount(liveNeutronData: messages.Rad.NeutronReading){

        var avg_neutron_count = 0;
        var num_det_count = 0;
        var neutron_rate_string = 'N/A';

        if(liveNeutronData !== undefined){

            liveNeutronData.detectors.forEach((det) => {
                if (det.count != null) {
                    if(det.lane_position === this.props.lanePosition){
                        avg_neutron_count = avg_neutron_count + det.count/det.livetime; //to convert to cps
                        num_det_count++;
                    }
                }
            });
            /*
            avg_neutron_count = neutronData.count / neutronData.livetime;
            num_det_count = neutronData.num_det;
            */
            if (num_det_count > 0) {
                avg_neutron_count = avg_neutron_count / num_det_count;
                neutron_rate_string = avg_neutron_count.toFixed(1);
            } else {
                neutron_rate_string = 'N/A';
            }
        }
        /*
        if(this.props.healthData.state === messages.Rad.HealthState.BAD){
            neutron_rate_string = 'N/A';
        }
        */
        this.numDetectorsInLane = num_det_count;
        return({neutron_rate_string});
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    getStatusClass(){
        let statusClass = 'good';
        if(this.numDetectorsInLane <= 0 ){
            statusClass = 'bad';
        }
        return(statusClass)
    }

    render() {
        /*
        this.startTimer();
        const thisHealthData = this.props.healthData;
        var healthStatusClass;
        if(thisHealthData.lastMessage.getTime()+this.heartbeatInterval >= new Date().getTime()){
            //Not Timeout
            healthStatusClass =  healthStateToClass(thisHealthData.state);
        } else {
            healthStatusClass =  "offline";
        }
        */
        this.startTimer();
        var healthStatusClass = "good";
        var neutron_display_string = 'N/A';
        if(this.props.liveNeutronData !== null){
            if(this.props.liveNeutronData.length > 0){
                if(this.props.liveNeutronData[this.props.liveNeutronData.length-1].time+this.heartbeatInterval >= new Date().getTime()){
                    const result = this.calculateNeutronCount(this.props.liveNeutronData[this.props.liveNeutronData.length-1]);
                    healthStatusClass = this.getStatusClass();
                    neutron_display_string = result.neutron_rate_string;
                } else {
                    healthStatusClass =  "offline";
                }
            } else {
                //No DATA
                healthStatusClass =  "offline";
            }
        }

        const neutron_body =
            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'baseline', padding: '2px' }}>
                <label className={"metric "+healthStatusClass}>{neutron_display_string}</label>
                <label className="units">cps</label>
            </div>
        return (
            <div className="primary-metric-container small" style={{marginTop:'2px', marginBottom:'2px', padding: '2px'}}>
                <label className="metric-title" style={{whiteSpace:'nowrap'}}>Neutron Rate</label>
                {neutron_body}
            </div>
        )
    }
}

//******************************************************************************
export interface PrimaryCountHistoryPlotProps {
    gammaCounts: GammaCount[];
    maxGamma: number | null;
    neutronCounts: NeutronCount[];
    maxNeutron: number | null;
    replayTime?: Date,
    liveStream: boolean,
    //onSelectRange: (start_time: number | null, end_time: number | null) => void;
    //setStartTime: (start_time: number) => void;
}

export class PrimaryCountHistoryPlot extends React.Component<PrimaryCountHistoryPlotProps> {
    base: HTMLDivElement | null
    updateRef: (element: HTMLDivElement) => void
    //previous_brush: [number, number] | undefined;

    plot_margin = { top: 10, right: 7, bottom: 15, left: 7 };
    count_rate_x: d3.ScaleTime<number, number> | null = null;
    count_rate_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    count_rate_g: any | null
    neutron_count_rate_x: d3.ScaleTime<number, number> | null = null;
    neutron_count_rate_y: d3.ScaleContinuousNumeric<number, number> | null = null;
    neutron_count_rate_g: any | null
    count_rate_width: number = 0
    count_rate_height: number = 0
    //source_brush: d3.BrushBehavior<unknown> | null = null;
    //brush_path: any;
    history_plot_range_msec = 120000;
    plot_scale_min_gamma = 4000; //cps
    plot_scale_min_neutron = 40; //cps

    resize_busy:boolean=false;
    resize_timer:NodeJS.Timeout | null = null;
    resize_incomplete:boolean=false;

    prev_window_width:number=0;
    curr_window_width:number=0;

    constructor(props: PrimaryCountHistoryPlotProps) {
        super(props)
        this.base = null

        this.resize = this.resize.bind(this);

        this.updateRef = (element: HTMLDivElement) => {
            this.base = element;
            this.renderPlot();
        };
    }

    componentDidMount() {
        this.initPlot()
        this.renderPlot();
        window.addEventListener("resize", this.resize);
    }

    componentDidUpdate(prevProps: PrimaryCountHistoryPlotProps) {
        //Pending resize
        this.curr_window_width = window.innerWidth;
        if(this.curr_window_width !== this.prev_window_width ){
            this.resize();
        }
        //Update plot if not resizing
        if (this.props.gammaCounts !== prevProps.gammaCounts || this.props.neutronCounts !== prevProps.neutronCounts) {
            if(!this.resize_busy){
                if(this.resize_incomplete){
                    this.initPlot();
                    this.resize_incomplete = false;
                }
            this.renderPlot();
            }
        }
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.resize);
    }

    resize() {
        //Clear plot for faster redraw
        d3.select(this.base!).select("svg").remove();

        if(this.curr_window_width === window.innerWidth){
            this.prev_window_width = this.curr_window_width;
            //Throttle resize redraw
            if(!this.resize_busy){
                this.resize_busy = true;
                this.initPlot()
                this.renderPlot();
                this.resize_timer = setTimeout(()=>{
                    this.resize_busy = false;
                },200)
            } else {
                this.resize_incomplete = true;
            }
        }
    }


    initPlot() {
        d3.select(this.base!).select("svg").remove();
        const width = this.base!.clientWidth - 0;  // subtract 20 to compensate for margins
        const height = this.base!.clientHeight - 0;

        this.count_rate_width = width -
            this.plot_margin.left - this.plot_margin.right;
        this.count_rate_height = height -
            this.plot_margin.top - this.plot_margin.bottom;

        //d3.select(this.base!).select("svg").remove();

        const count_rate_svg = d3.select(this.base!).append("svg")
            .attr("width", `${width}px`)
            .attr("height", `${height}px`);

        //Neutron Plot
        this.neutron_count_rate_g = count_rate_svg.append('g').attr(
            'transform', 'translate(' + this.plot_margin.left + ',' +
            this.plot_margin.top + ')');

        this.neutron_count_rate_g.selectAll('.plot-axis').remove();
        this.neutron_count_rate_g.selectAll('path').remove();

        this.neutron_count_rate_x =
            d3.scaleTime().rangeRound([0, this.count_rate_width]);
        this.neutron_count_rate_y =
            d3.scaleLinear().rangeRound([this.count_rate_height, 0]);

        //Gamma Plot
        this.count_rate_g = count_rate_svg.append('g').attr(
            'transform', 'translate(' + this.plot_margin.left + ',' +
            this.plot_margin.top + ')');

        this.count_rate_g.selectAll('.plot-axis').remove();
        this.count_rate_g.selectAll('path').remove();

        this.count_rate_x =
            d3.scaleTime().rangeRound([0, this.count_rate_width]);
        this.count_rate_y =
            d3.scaleLinear().rangeRound([this.count_rate_height, 0]);
/*
        this.source_brush =
            d3.brushX().on('brush end', this.on_source_brush.bind(this));

        this.brush_path = this.count_rate_g.append('g')
            .attr('class', 'brush')
            .call(this.source_brush);
*/
    }

    renderPlot() {
        if (this.count_rate_x !== null && this.count_rate_y !== null) {
            let max_all_x = 0;
            let min_plot_x = 0;

            //Find common x domain between gamma and neutron data
            if(this.props.neutronCounts !== null){
                //Neutron data exists
                if(this.neutron_count_rate_x !== null && this.neutron_count_rate_y !== null){
                    if(this.props.gammaCounts.length > 0){
                        //Neutron and Gamma data exist
                        let max_gamma_x = d3.max(this.props.gammaCounts, function (d) { return d.time }) || 0;
                        let min_gamma_x = d3.min(this.props.gammaCounts, function (d) { return d.time }) || 0;

                        let max_neutron_x = d3.max(this.props.neutronCounts, function (d) { return d.time }) || 0;
                        let min_neutron_x = d3.min(this.props.neutronCounts, function (d) { return d.time }) || 0;

                        max_all_x = Math.max(max_gamma_x,max_neutron_x);
                        var min_all_x=0;
                        if(min_gamma_x > 0){
                            if(min_neutron_x > 0){
                                min_all_x = Math.min(min_gamma_x,min_neutron_x);
                            } else {
                                min_all_x = min_gamma_x;
                            }
                        } else {
                            if(min_neutron_x > 0){
                                min_all_x = min_neutron_x;
                            } else {
                                min_all_x = 0;
                            }
                        }

                        min_plot_x = min_all_x;

                        if(this.props.liveStream === true){
                            if(min_plot_x < max_all_x-this.history_plot_range_msec && min_plot_x > 0){
                                min_plot_x = max_all_x-this.history_plot_range_msec;
                            }
                        }

                        this.neutron_count_rate_x.domain([
                            min_plot_x,
                            max_all_x
                        ]);
                        this.count_rate_x = this.neutron_count_rate_x;

                    } else {
                        //Neutron data only
                        this.neutron_count_rate_x.domain([
                            d3.min(this.props.neutronCounts, function (d) { return d.time }) || 0,
                            d3.max(this.props.neutronCounts, function (d) { return d.time }) || 0
                        ]);
                        this.count_rate_x = this.neutron_count_rate_x;
                    }
                }

            } else {
                //Neutron data doesn't exist
                if(this.props.gammaCounts.length > 0){
                    //Gamma data only
                    this.count_rate_x.domain([
                        d3.min(this.props.gammaCounts, function (d) { return d.time }) || 0,
                        d3.max(this.props.gammaCounts, function (d) { return d.time }) || 0
                    ]);
                    this.neutron_count_rate_x = this.count_rate_x;
                } else {
                    //NO VALID DATA

                }
            }
            //this.props.setStartTime(min_plot_x);

            //Y axis limits
            var gamma_maxval_y = 0;
            var gamma_minval_y = 100000;

            const validData = this.props.gammaCounts.filter(function (d) { return d.sum !== null }).filter(function (d) { return d.time >= min_plot_x});;
            this.count_rate_y.domain([
                d3.min(validData, function (d) { return d.sum / d.livetime }) || 0,
                d3.max(validData, function (d) { return d.sum / d.livetime }) || 0
            ]);

            //Find max and min of gamma
            if(this.count_rate_y.domain()[1] > gamma_maxval_y){
                gamma_maxval_y = this.count_rate_y.domain()[1];
            }
            if(this.count_rate_y.domain()[0] < gamma_minval_y){
                gamma_minval_y = this.count_rate_y.domain()[0];
            }
            if(this.props.maxGamma !== null){
                if(gamma_maxval_y < this.props.maxGamma){
                    gamma_maxval_y = this.props.maxGamma;
                }
            }
            //Set range for plots
            if (gamma_maxval_y < this.plot_scale_min_gamma){
                this.count_rate_y.domain([gamma_minval_y,this.plot_scale_min_gamma]);
            } else {
                this.count_rate_y.domain([gamma_minval_y,gamma_maxval_y]);
            }

            var xscale = this.count_rate_x;
            var yscale = this.count_rate_y;

            // clang-format off
            this.count_rate_g.selectAll('.plot-axis').remove();
            this.count_rate_g.selectAll('.replay-time').remove();
            this.count_rate_g.selectAll('path').remove();
            this.neutron_count_rate_g.selectAll('.neutron-plot-axis').remove();
            this.neutron_count_rate_g.selectAll('path').remove();

            //Gamma Plot
            this.count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .attr('transform', 'translate(0,' + this.count_rate_height + ')')
                .style("font-size", "7px")
                .call(d3.axisBottom(xscale).scale(xscale).tickSize(2).ticks(8))

            this.count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .style("font-size", "7px")
                .attr("text-anchor", "middle")
                .attr("transform","translate("+this.plot_margin.left*3+",0)")
                .call(d3.axisLeft(yscale).tickSize(1).ticks(2))
                .select(".domain").remove();

            this.count_rate_g.append('g')
                .attr('class', 'plot-axis')
                .append("text")
                .attr("text-anchor", "left")  // this makes it easy to centre the text as the transform is applied to the anchor
                .attr("transform", "translate(-"+ this.plot_margin.left*0.7 +","+"-5"+")rotate(0)")  // text is drawn off the screen top left, move down and out and rotate
                .attr("fill",'olivedrab')
                .style("font-size", "7px")
                .text("Gamma");

            this.count_rate_g.append('path')
                .datum(this.props.gammaCounts)
                .attr('fill', 'none')
                .attr('stroke', 'olivedrab')
                .attr('stroke-width', 1.5)
                .attr('d', d3.line()
                    .x(function (d: any) { return xscale(d.time) as number})
                    .defined(function (d: any) { return d.sum !== null; })
                    .defined(function (d: any) { return d.time > min_plot_x; })
                    .y(function (d: any) { return yscale(d.sum / d.livetime) as number })
                );

            //Neutron plot
            if(this.props.neutronCounts !== null){
                const validNeutronData = this.props.neutronCounts.filter(function (d) { return d.count !== null }).filter(function (d) { return d.time >= min_all_x});
                if(this.neutron_count_rate_x !== null && this.neutron_count_rate_y !== null){

                    var neutron_maxval_y = 0;
                    var neutron_minval_y = 100000;

                    this.neutron_count_rate_y.domain([
                        d3.min(validNeutronData, function (d) { return d.count / d.livetime }) || 0,
                        d3.max(validNeutronData, function (d) { return d.count / d.livetime }) || 0
                    ]);

                    /*
                    if (this.neutron_count_rate_y.domain()[1] < 10){
                        var minval = this.neutron_count_rate_y.domain()[0];
                        this.neutron_count_rate_y.domain([minval,10]);
                    }
                    */

                    //Find max and min of neutron
                    if (this.neutron_count_rate_y.domain()[1] > neutron_maxval_y){
                        neutron_maxval_y = this.neutron_count_rate_y.domain()[1];
                    }
                    if (this.neutron_count_rate_y.domain()[0] < neutron_minval_y){
                        neutron_minval_y = this.neutron_count_rate_y.domain()[0];
                    }
                    if(this.props.maxNeutron !== null){
                        if(neutron_maxval_y < this.props.maxNeutron){
                            neutron_maxval_y = this.props.maxNeutron;
                        }
                    }
                    if (neutron_maxval_y < this.plot_scale_min_neutron){
                        this.neutron_count_rate_y.domain([neutron_minval_y,this.plot_scale_min_neutron]);
                    } else {
                        this.neutron_count_rate_y.domain([neutron_minval_y, neutron_maxval_y]);
                    }


                    let neutron_xscale = this.neutron_count_rate_x;
                    let neutron_yscale = this.neutron_count_rate_y;


                    this.neutron_count_rate_g.append('g')
                        .attr('class', 'neutron-plot-axis')
                        .style("font-size", "7px")
                        .attr("text-anchor", "middle")
                        .attr("transform","translate("+(this.count_rate_width-this.plot_margin.right*3)+",0)")
                        .call(d3.axisRight(neutron_yscale).scale(neutron_yscale).tickSize(1).ticks(2))
                        .select(".domain").remove();

                    const bbox = this.neutron_count_rate_g.selectAll('.neutron-plot-axis').node().getBBox();

                    this.neutron_count_rate_g.selectAll('.neutron-plot-axis')
                      .attr("transform","translate("+(this.count_rate_width-bbox.width)+",0)")

                    this.neutron_count_rate_g.append('g')
                    .attr('class', 'neutron-plot-axis')
                    .append("text")
                    .attr("text-anchor", "right")  // this makes it easy to centre the text as the transform is applied to the anchor
                    .attr("transform", "translate("+ (this.count_rate_width-this.plot_margin.right*3) +","+"-5"+")rotate(0)")  // text is drawn off the screen top left, move down and out and rotate
                    .attr("fill",'steelblue')
                    .style("font-size", "7px")
                    .text("Neutron");

                    this.neutron_count_rate_g.append('path')
                        .datum(this.props.neutronCounts)
                        .attr('fill', 'none')
                        .attr('stroke', 'steelblue')
                        .attr('stroke-width', 1.5)
                        .attr('d',d3.line()
                            .x(function (d: any) { return neutron_xscale(d.time) as number})
                            .defined(function (d: any) { return d.count !== null; })
                            .defined(function (d: any) { return d.time > min_plot_x; })
                            .y(function (d: any) { return neutron_yscale(d.count / d.livetime) as number })
                        );
                }
            }
/*
            if (this.source_brush !== null) {
                if (this.previous_brush !== undefined) {
                    var xs = this.previous_brush.map(xscale);
                    if (xs[0] < 0)
                        xs[0] = 0;

                    if (xs[1] > 0) {
                        this.brush_path.call(this.source_brush.move, xs);
                    } else {
                        this.previous_brush = undefined;
                        this.brush_path.call(this.source_brush.move, null);
                    }
                }
            }
*/
            if (this.props.replayTime && !this.props.liveStream) {
                var pos = this.count_rate_x(this.props.replayTime);
                if(pos === undefined)
                    pos = 0;
                if (pos < 0)
                    pos = 0;
                if (pos > this.count_rate_width)
                    pos = this.count_rate_width;

                this.count_rate_g.append("line")
                    .attr('class', 'replay-time')
                    .attr("x1", pos)
                    .attr("y1", 0)
                    .attr("x2", pos)
                    .attr("y2", this.count_rate_height)
                    .style("stroke-width", 2)
                    .style("stroke", "red")
                    .style("fill", "none");

            }
        }
    }

    render() {
        return (
            <div className="Plot" style={{ display: 'flex', flexDirection: 'column', height: '100px', margin:'3px'}}>
                <div className="plot" ref={this.updateRef} style={{ display: 'flex', flex: '1 1 0%', margin:'0px'}} />
            </div>
        )
    }
}

//******************************************************************************

export interface LaneHealthAndContextDisplayProps {
    lanePosition: number,
    gammaCounts: GammaCount[],
    neutronCounts: NeutronCount[],
    investigations: Investigation[],
    replayInvestigation?: Investigation,
    investigationsNotAcknowledged?: Investigation[],
    attributionSummary?: Map<String,messages.Contextual.SourceAttributionSummary>,
    liveStream: boolean,
    isCommercial?: boolean,
    isSecondary?:boolean,
    showAttrImage?: boolean,
    lineOverlayMap?: Map<number,ImagePoint[]>,
    singleLaneView?: boolean,
    isDualStanchion?: boolean,
}
export interface LaneHealthAndContextDisplayState {
    time: Date,
}
export class LaneHealthAndContextDisplay extends React.Component<LaneHealthAndContextDisplayProps,LaneHealthAndContextDisplayState> {
    heartbeatInterval:number = 10000*1.2; //msec
    heartbeatTimer:NodeJS.Timeout | null = null;
    laneHealthStatusClass:string = "";
    laneHealthStatusString:string = "N/A"
    laneDataLoaded:boolean = false;

    isAltAttr: boolean = false;

    investigationDisplayed: Investigation | undefined = undefined;
    lastData: number=0;
    forceImageResize:boolean = false;

    constructor(props: LaneHealthAndContextDisplayProps) {
        super(props)
        this.state = {
            time: new Date(),
        }
    }

    componentDidMount() {
        //window.addEventListener("resize", this.resize);

    }

    componentWillUnmount() {
        if (this.heartbeatTimer !== null) {
            clearTimeout(this.heartbeatTimer);
        }
        this.investigationDisplayed = undefined;

    }

    componentDidUpdate(prevProps: LaneHealthAndContextDisplayProps){
        if (this.props.liveStream !== prevProps.liveStream) {
            this.investigationDisplayed = undefined;
        }

        if(this.checkForExtraAttributionImage(prevProps)){
            this.forceImageResize = true;
        } else {
            this.forceImageResize = false;
        }
    }

    startTimer(){
        if(this.heartbeatTimer !== null){
            clearTimeout(this.heartbeatTimer);
        }
        this.heartbeatTimer = setTimeout(() =>{
            //Change in state triggers redraw
            this.setState({time: new Date()});
        },this.heartbeatInterval)
    }

    checkForExtraAttributionImage(prevProps: LaneHealthAndContextDisplayProps){
        let prevAttributionSummarycount = 0;
        prevProps.attributionSummary?.forEach((value, key) => {
            if(value.source_image !== null){
                prevAttributionSummarycount++;
            }
        })

        let attributionSummarycount = 0;
        this.props.attributionSummary?.forEach((value, key) => {
            if(value.source_image !== null){
                attributionSummarycount++;
            }
        })
        if(prevAttributionSummarycount !== attributionSummarycount){
            return true
        } else {
            return false
        }
    }

    updateLaneHealthClassAndString(){
        this.laneHealthStatusClass = "";
        this.laneHealthStatusString = "WAIT";
        this.laneDataLoaded=false;
        let gammaOnline:boolean|null = null;
        let gammaDegradedCOV:boolean = false;
        let neutronOnline:boolean|null = null;
        let neutronDegradedSecondary:boolean = false;
        if(this.props.gammaCounts !== null){
            if(this.props.liveStream){
                //Live data
                if(this.props.gammaCounts.length > 0){
                    if(this.props.gammaCounts[this.props.gammaCounts.length-1].time+this.heartbeatInterval >= new Date().getTime()){
                        if(this.props.gammaCounts[this.props.gammaCounts.length-1].num_det > 0){
                            gammaOnline = true;
                            this.lastData = new Date().getTime();
                            if(this.props.isCommercial){
                                //COV
                                if(this.props.isSecondary){
                                    //Secondary COV
                                    if(this.props.gammaCounts[this.props.gammaCounts.length-1].num_det < 4){
                                        gammaDegradedCOV = true;
                                    }
                                } else {
                                    //Primary COV
                                    if(this.props.gammaCounts[this.props.gammaCounts.length-1].num_det < 2){
                                        gammaDegradedCOV = true;
                                    }
                                }
                            } else {
                                if(this.props.isSecondary){
                                    //Secondary POV
                                    if(this.props.gammaCounts[this.props.gammaCounts.length-1].num_det < 2){
                                        gammaDegradedCOV = true;
                                    }
                                }
                            }
                        } else {
                            gammaOnline = false;
                        }
                    } else {
                        //Timeout = no new data
                        gammaOnline = false;
                    }
                } else {
                    //No DATA
                    if(this.lastData+3000 < new Date().getTime()){
                        gammaOnline = false;
                    }
                    //console.log("lane "+ this.props.lanePosition+" gammaOnline "+gammaOnline);
                }
            } else {
                //Replay Data
                if(this.props.gammaCounts.length > 0){
                    if(d3.sum(this.props.gammaCounts,function (d:any) { return d.num_det} ) > 0){
                        gammaOnline = true;
                    } else {
                        gammaOnline = false;
                    }
                    this.lastData = new Date().getTime();
                }
            }
        }
        if(this.props.neutronCounts !== null){
            if(this.props.liveStream){
                if(this.props.neutronCounts.length > 0){
                    if(this.props.neutronCounts[this.props.neutronCounts.length-1].time+this.heartbeatInterval >= new Date().getTime()){
                        if(this.props.neutronCounts[this.props.neutronCounts.length-1].num_det > 0){
                            neutronOnline = true;
                            this.lastData = new Date().getTime();
                            if(this.props.isSecondary || this.props.isDualStanchion){
                                //Secondary COV and POV or Dual Stanchion
                                if(this.props.neutronCounts[this.props.neutronCounts.length-1].num_det < 2){
                                    neutronDegradedSecondary = true;
                                }
                            }
                        } else {
                            neutronOnline = false;
                        }
                    } else {
                        //No new data
                        neutronOnline = false
                    }
                } else {
                    if(this.lastData+3000 < new Date().getTime()){
                        //No DATA after timeout
                        neutronOnline = false
                    }
                }
            } else {
                //Replay Data
                if(this.props.neutronCounts.length > 0){
                    if(d3.sum(this.props.neutronCounts,function (d:any) { return d.num_det} ) > 0){
                        neutronOnline = true;
                    } else {
                        neutronOnline = false;
                    }
                    this.lastData = new Date().getTime();
                }
            }
        }
        if(gammaOnline !== null || neutronOnline !== null){
            if(gammaOnline !== null && gammaOnline==true){
                if(neutronOnline == true && neutronOnline !== null){
                    if(gammaDegradedCOV || neutronDegradedSecondary){
                        this.laneHealthStatusString = "ATTN"
                        this.laneHealthStatusClass = "degraded";
                    } else {
                        this.laneHealthStatusString = "OK"
                        this.laneHealthStatusClass = "good";
                    }
                } else {
                    //Gamma only
                    this.laneHealthStatusString = "ATTN"
                    this.laneHealthStatusClass = "degraded";
                }
            } else {
                if(neutronOnline == true && neutronOnline !== null){
                    //this.laneHealthStatusString = "ATTN"
                    //this.laneHealthStatusClass = "degraded";
                    //NOTE: Even if neutron is online, if gamma is offline, then show offline
                    this.laneHealthStatusString = "OFFLINE"
                    this.laneHealthStatusClass = "offline";
                } else {
                    this.laneHealthStatusString = "OFFLINE"
                    this.laneHealthStatusClass = "offline";
                }
            }
            this.laneDataLoaded = true;
        } else {
            this.laneHealthStatusString = "WAIT"
            this.laneHealthStatusClass = "";
            this.laneDataLoaded = false;
        }
    }

    hyphenated_nuclide_name(underscore_name: string) {
        var output = underscore_name;
        if (underscore_name.includes("_")) {
            var res = underscore_name.split("_");
            var nuclide_symbol = res[0].toLowerCase();
            var nuclide_number = res[1];
            output = nuclide_symbol[0].toUpperCase() + nuclide_symbol.slice(1) +
                "-" + nuclide_number.toLowerCase();
        }
        return output;
    }

    get_isotope_color(isot_class: string) {
        var this_display_category = isot_class.toUpperCase();
        var color = 'olivedrab'; // NORM

        // COLOR DEFINITION OF
        if (this_display_category.match('INDUSTRIAL')) {
            color = 'orange';
        }
        if (this_display_category.match('RDD')) {
            color = 'orange';
        }
        if (this_display_category.match('MEDICAL')) {
            color = '#4f86f7';
        }
        if (this_display_category.match('SNM')) {
            color = 'red';
        }
        if (this_display_category.match('NUCLEAR')) {
            color = 'red';
        }
        if (this_display_category.match('OVERRANGE')) {
            color = 'OrangeRed';
        }
        if (this_display_category.match('HIGH_DOSE')) {
            color = 'OrangeRed';
        }
        return color;
    }

    get_class_icon(isot_class: string){
        const this_display_category = isot_class.toUpperCase();
        let icon = icon_attention_logo; // Attention
        if (this_display_category === 'INDUSTRIAL') {
            icon = icon_industrial_logo;
        }
        if (this_display_category === 'RDD') {
            icon = icon_industrial_logo;
        }
        // if (this_display_category == 'MEDICAL') {
        if (this_display_category === 'MEDICAL') {
            icon = icon_medical_logo;
        }
        if (this_display_category === 'SNM') {
            icon = icon_nuclear_logo;
        }
        if (this_display_category === 'NUCLEAR') {
            icon = icon_nuclear_logo;
        }
        if (this_display_category === 'OVERRANGE') {
            icon = icon_attention_logo;
        }
        if (this_display_category === 'HIGH_DOSE') {
            icon = icon_attention_logo;
        }
        if (this_display_category === 'NORM') {
            icon = icon_norm_logo;
        }
        return icon;
    }

    render() {

        this.startTimer();
        this.updateLaneHealthClassAndString();

        let lane_health_context_body = null;
        let lane_attribution_body = null;
        let lane_source_direction_body = null;
        let inv_color = "#333";
        let lane_class = "";

        if(this.props.liveStream){
            //Live, show last investigation not dismissed
            if(this.props.investigationsNotAcknowledged !== undefined && this.props.investigationsNotAcknowledged.length > 0){
                //There are unacknowledged investigations
                if(this.props.investigationsNotAcknowledged.length > 0 && this.laneHealthStatusClass !== 'offline'){
                    this.investigationDisplayed = this.props.investigationsNotAcknowledged[this.props.investigationsNotAcknowledged.length-1]
                } else {
                    this.investigationDisplayed = undefined;
                }
            } else {
                //All investigations are acknowledged, so display current inv as long as it is not closed
                this.investigationDisplayed = this.props.investigations[this.props.investigations.length-1];
                if(this.investigationDisplayed !== undefined){
                    if(!(this.props.liveStream && !this.investigationDisplayed.finalized)){
                        this.investigationDisplayed = undefined;
                    }
                }
            }
        } else {
            //replay
            if(this.props.replayInvestigation !== undefined){
                if(this.investigationDisplayed !== this.props.replayInvestigation){
                    this.investigationDisplayed = this.props.replayInvestigation;
                }
            }
        }

        if(this.investigationDisplayed !== undefined && this.laneDataLoaded){
            if(this.investigationDisplayed.source_lane === this.props.lanePosition || AltAttributionUtil.isAltAttrInThisLane(this.investigationDisplayed,this.props.lanePosition)){

                let this_inv_disp_isotope_name = "";
                let this_inv_disp_isotope_category = "";
                this.isAltAttr = false;
                if(this.investigationDisplayed.source_lane === this.props.lanePosition) {
                    this_inv_disp_isotope_name = this.investigationDisplayed.isotopes[0].name;
                    this_inv_disp_isotope_category = this.investigationDisplayed.isotopes[0].category;
                } else if(AltAttributionUtil.isAltAttrInThisLane(this.investigationDisplayed,this.props.lanePosition)) {
                    this_inv_disp_isotope_name = AltAttributionUtil.getAltAttrIsotopeName(this.investigationDisplayed);
                    this_inv_disp_isotope_category = AltAttributionUtil.getAltAttrIsotopeCategory(this.investigationDisplayed);
                    this.isAltAttr = true;
                }

                let inv_class;
                let inv_icon;
                let inv_isot;
                let rect_color = 'red'; //DEFAULT is RED
                let neutron_det = false;

                if(this_inv_disp_isotope_name === "OVERRANGE"){
                    inv_class = "ID UNCERTAIN";
                    inv_icon = this.get_class_icon("OVERRANGE");
                    inv_isot = "OVERRANGE";
                    inv_color = this.get_isotope_color("OVERRANGE");
                } else if(this_inv_disp_isotope_name=== "HIGH_DOSE"){
                    inv_class = "CAUTION";
                    inv_icon = this.get_class_icon("HIGH_DOSE");
                    inv_isot = "HIGH DOSE";
                    inv_color = this.get_isotope_color("HIGH_DOSE");
                } else {
                    inv_class = this_inv_disp_isotope_category;
                    inv_icon = this.get_class_icon(inv_class);
                    inv_isot = this.hyphenated_nuclide_name(this_inv_disp_isotope_name);
                    inv_color = this.get_isotope_color(inv_class);
                    if(this_inv_disp_isotope_name === "NEUTRONS"){
                        rect_color = 'blue';
                        neutron_det = true;
                    }
                }

                lane_health_context_body =
                    <div className="primary-metric-container" style={{padding: '2px', alignItems:'start', flex: 'none'}}>
                        <div style={{ display: 'flex', flexDirection: 'row', alignSelf: 'center'}}>
                            <div className='lane-threat-class-image'>
                                <img src={inv_icon} style={{color: inv_color}}alt={inv_class} />
                            </div>
                            <div style={{ display: 'flex', flex: '1', flexDirection: 'column'}}>
                                <label className={"lane-threat-isotope metric"}><span style={{color: inv_color}}>{inv_isot}</span></label>
                                <label className={"lane-threat-class metric"}><span style={{color: inv_color}}>{inv_class}</span></label>
                            </div>
                        </div>
                    </div>

                if(this.props.showAttrImage){

                    const lineOverlay = this.props.lineOverlayMap?.get(this.props.lanePosition);

                    if(this.isAltAttr){
                        //Alternative attribution
                        lane_attribution_body =
                            <div className="primary-metric-container" style={{display:'flex', padding:'0px', flexDirection:'column', alignItems:'center', background:'black'}}>
                                <AttributionImageLoaderAndDisplay
                                    investigation={this.investigationDisplayed}
                                    lineOverlay={lineOverlay}/>
                            </div>;

                    } else {
                        //Primary attribution
                        let attribution_elements:JSX.Element[] = [];
                        this.props.attributionSummary?.forEach((value, key) => {
                            if(value.source_image !== null){
                                //Only display attribution with image
                                let this_attribution_display = <AttributionImageLoaderAndDisplay
                                    key={key.toString()}
                                    attributionSummary={value}
                                    investigation={this.investigationDisplayed}
                                    lineOverlay={lineOverlay}
                                    forceImageResize={this.forceImageResize}/>

                                if(value.source_rect === null){
                                    //Place simple attribution image with gantry overlay on top
                                    attribution_elements.unshift(this_attribution_display);
                                } else {
                                    //Place automated attribution image below
                                    attribution_elements.push(this_attribution_display);
                                }
                            }
                        })
                        if(this.props.singleLaneView){
                            lane_attribution_body =
                                <div className="primary-metric-container" style={{display:'flex', padding:'0px', flexDirection:'row', alignItems:'center', background:'black'}}>
                                    {attribution_elements}
                                </div>
                        } else {
                            lane_attribution_body =
                                <div className="primary-metric-container" style={{display:'flex', padding:'0px', flexDirection:'column', alignItems:'center', background:'black'}}>
                                    {attribution_elements}
                                </div>;
                        }

                    }

                    if(this.props.isCommercial){
                        let source_direction_top = "";
                        let source_direction_bottom = "";

                        if(this.investigationDisplayed.source_lane_position !== null){
                            if(this.investigationDisplayed.source_lane_position === 0){
                                //BOTTOM
                                if(neutron_det){
                                    source_direction_bottom = "neutron";
                                } else {
                                    source_direction_bottom = "alarm";
                                }
                            } else if (this.investigationDisplayed.source_lane_position === 1) {
                                //TOP
                                if(neutron_det){
                                    source_direction_top = "neutron";
                                } else {
                                    source_direction_top = "alarm";
                                }
                            }
                        } else {
                            //BOTH
                            if(neutron_det){
                                source_direction_top = "neutron";
                                source_direction_bottom = "neutron";
                            } else {
                                source_direction_top = "alarm";
                                source_direction_bottom = "alarm";
                            }
                        }

                        lane_source_direction_body =
                        <div className="primary-metric-container" style={{height: '105px', flex:'none', alignItems:'center', marginTop:'2px', marginBottom:'2px', padding: '2px', position:'relative'}}>
                            <div style={{ display: 'flex', flexDirection:'column', alignItems:'center', position: 'absolute'}}>
                                <label className={"metric "+source_direction_top}>TOP</label>
                                <img src={icon_truck_logo} style={{height:'60px'}}/>
                                <label className={"metric "+source_direction_bottom}>BOTTOM</label>
                            </div>
                            <div className={"primary-source-direction-container "+source_direction_top}></div>
                            <div className={"primary-source-direction-container "+source_direction_bottom}></div>
                        </div>
                    }
                    lane_class = "stretch";

                }

            } else {
                lane_health_context_body =
                    <div className="primary-metric-container" style={{marginTop:'2px', marginBottom:'2px', padding: '2px'}}>
                        <label className={"primary-metric-only metric  "+this.laneHealthStatusClass}>{this.laneHealthStatusString }</label>
                    </div>
            }

        } else {
            lane_health_context_body =
                <div className="primary-metric-container" style={{marginTop:'2px', marginBottom:'2px', padding: '2px'}}>
                    <label className={"primary-metric-only metric "+this.laneHealthStatusClass}>{this.laneHealthStatusString }</label>
                </div>
        }

        return (
            <>
            <div className={"primary-lane-card-container "+lane_class} style={{marginTop:'2px', marginBottom:'2px', padding: '2px', backgroundColor: inv_color}}>
                {lane_health_context_body}
                {lane_attribution_body}
            </div>
            {lane_source_direction_body}
            <div style={{height:'10px'}}/>
            </>
        )
    }
}

//******************************************************************************
